module.exports = __webpack_public_path__ + "img/escaner-icon.cfe24a11.png";